import './App.scss';
import React, { useEffect, useState } from 'react';
import { Dropdown, Grid, Header, Icon, Modal, Segment } from 'semantic-ui-react';
import $ from 'jquery';

const tbaKey = 'bt1wQbg66dQBTD1c0Qd6n2qFa6Ai2KsXXfZgexLjp7CI85YMtMNfe461vGsmiMgG';

// Match sorting: comp_level -> set_number -> match_number
const matchOrder = { 'qm': 0, 'qf': 3, 'sf': 7, 'f': 10 };
const compLevelMap = { 'qm': 'Qual', 'sf': 'Semi', 'f': 'Final' };

function App() {
	const [loading, setLoading] = useState(true);
	const [player, setPlayer] = useState(undefined);
	const [showHelp, setShowHelp] = useState(false);

	const [muted, setMuted] = useState(true);
	const [paused, setPaused] = useState(false);

	// Main control
	const years = Array.from({ length: (new Date().getFullYear()) - 1992 + 1 }, (value, index) => (1992 + index).toString()).reverse();
	const yearDropdownOptions = years.map((year) => ({ key: year, text: year, value: year }));
	const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());

	// Determiend by year
	const [events, setEvents] = useState({});
	const [teams, setTeams] = useState({});

	// On event select
	const [selectedEvent, setSelectedEvent] = useState(null);
	const [filteredTeams, setFilteredTeams] = useState(null);
	const teamDropdownOptions = Object.values(filteredTeams ?? teams).sort(
		(first, second) => first.value.length - second.value.length || first.value > second.value);
	
	// On team select
	const [selectedTeam, setSelectedTeam] = useState(null);
	const [filteredEvents, setFilteredEvents] = useState(null);
	const eventDropdownOptions = Object.values(filteredEvents ?? events);

	// On event + team select
	const [matches, setMatches] = useState([]);
	const [selectedMatch, setSelectedMatch] = useState(null);

	const matchTitle = selectedMatch !== null ? `${compLevelMap[matches[selectedMatch]?.compLevel] ?? ''}  ${matches[selectedMatch]?.compLevel === 'sf' ? matches[selectedMatch]?.setNumber ?? '' : matches[selectedMatch]?.matchNumber ?? ''}` : '';

	useEffect(() => {
		$.getScript('https://www.youtube.com/iframe_api', function () {
			window.YT.ready(function () {
				setPlayer(new window.YT.Player('video-container', { playerVars: { rel: 0 } }));
			});
		});
	}, []);

	const loadAllTeams = async () => {
		const singleTeamCall = async (pageNum) => {
			const response = await fetch(
				`https://www.thebluealliance.com/api/v3/teams/${selectedYear}/${pageNum}/simple`,
				{
					headers: {
						'Accept': 'application/json',
						'X-TBA-Auth-Key': tbaKey
					}
				}
			);
			const data = await response.json();
			return data;
		};

		const promises = [...Array(30).keys()].map(singleTeamCall);
		const responses = await Promise.all(promises);
		console.log('results', responses);
		return responses;
	}

	const clearSelection = () => {
		setFilteredEvents(null);
		setFilteredTeams(null);
		setSelectedEvent(null);
		setSelectedTeam(null);
		setMatches([]);
		setSelectedMatch(null);
	};

	// Load events and teams on year change
	useEffect(() => {
		clearSelection();
		setEvents({});
		setTeams({});
		if (!selectedYear) return;

		setLoading(true);
		console.log('fetching events for year', selectedYear);
		fetch(`https://www.thebluealliance.com/api/v3/events/${selectedYear}`,
			{
				headers: {
					'Accept': 'application/json',
					'X-TBA-Auth-Key': tbaKey
				}
			})
			.then((response) => { return response.json(); })
			.then((json) => {
				console.log('events json', json);
				// Sort events by date
				const sortedEvents = json.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
				setEvents(Object.fromEntries(sortedEvents.map(event => [event.key, { key: event.key, text: event.name, value: event.key }])));
			})
			.catch((error) => {
				console.log('error', error);
			});

		console.log('fetching teams for year', selectedYear);
		loadAllTeams()
			.then(teamResults => {
				var mergedResults = [].concat(...teamResults);
				const parsedTeams = Object.fromEntries(mergedResults.map(team => [team.key, { key: team.key.slice(3), text: team.key.slice(3) + ' - ' + team.nickname, value: team.key }]));
				console.log('parsed teams', parsedTeams);

				setTeams(parsedTeams);
				setLoading(false);
			});
	}, [selectedYear]);

	// Filter teams on event change
	useEffect(() => {
		if (!selectedEvent) return;

		setLoading(true);
		console.log('fetching teams for', selectedEvent, 'in year', selectedYear);
		fetch(`https://www.thebluealliance.com/api/v3/event/${selectedEvent}/teams/simple`, {
				headers: {
					'Accept': 'application/json',
					'X-TBA-Auth-Key': tbaKey
				}
			})
			.then((response) => {
				return response.json();
			})
			.then((json) => {
				console.log('teams at event json', json);
				var teamNumbers = Object.values(json).map(team => team.key);
				setFilteredTeams(Object.keys(teams)
					.filter(key => teamNumbers.includes(key))
					.reduce((obj, key) => {
						obj[key] = teams[key];
						return obj;
					}, {}));
			})
			.catch((error) => {
				console.log('error', error);
			})
			.finally(() => { setLoading(false); });
	}, [selectedEvent]);

	// Filter events on team change
	useEffect(() => {
		if (!selectedTeam) return;

		setLoading(true);
		console.log('fetching events for', selectedTeam, 'in year', selectedYear);
		fetch(`https://www.thebluealliance.com/api/v3/team/${selectedTeam}/events/${selectedYear}/simple`,
			{
				headers: {
					'Accept': 'application/json',
					'X-TBA-Auth-Key': tbaKey
				}
			})
			.then((response) => {
				return response.json();
			})
			.then((json) => {
				console.log('events for team json', json);
				var eventKeys = Object.values(json).map(event => event.key);
				setFilteredEvents(Object.keys(events)
					.filter((key) => eventKeys.includes(key))
					.reduce((obj, key) => {
						obj[key] = events[key];
						return obj;
					}, {}));
			})
			.catch((error) => {
				console.log('error', error);
			})
			.finally(() => { setLoading(false); });
	}, [selectedTeam]);

	// Fetch matches on event and team selection
	useEffect(() => {
		setSelectedMatch(null);
		setMatches({});
		if (!selectedTeam || !selectedEvent) return;

		console.log('fetching matches for', selectedTeam, 'at event', selectedEvent);
		fetch(`https://www.thebluealliance.com/api/v3/team/${selectedTeam}/event/${selectedEvent}/matches`,
			{
				headers: {
					'Accept': 'application/json',
					'X-TBA-Auth-Key': tbaKey
				}
			})
			.then((response) => {
				return response.json();
			})
			.then((json) => {
				console.log('matches json', json);
				const sortedMatches = json
					.map((match, index) => ({ key: match.key, text: match.key, value: match.key, video: match.videos?.find(x => x.type === 'youtube')?.key, compLevel: match.comp_level, setNumber: match.set_number, matchNumber: match.match_number, alliance: match.alliances.blue.team_keys.includes(selectedTeam) ? 'blue' : 'red' }))
					.sort((first, second) => matchOrder[first.compLevel] - matchOrder[second.compLevel] || first.setNumber - second.setNumber || first.matchNumber - second.matchNumber);
				setMatches(sortedMatches);
				console.log('sortedmatches', sortedMatches);
				if (sortedMatches.length) setSelectedMatch(0);
			})
			.catch((error) => {
				console.log('error', error);
			});
	}, [selectedTeam, selectedEvent]);

	// Change video on match change
	useEffect(() => {
		$("#video-container iframe")?.remove();
		$('#App').removeClass('red-alliance').removeClass('blue-alliance');
		if (!matches[selectedMatch]) return;
		if (!player) return;

		setPaused(false);
		console.log('match', selectedMatch, 'title', matches[selectedMatch]?.text, 'video', matches[selectedMatch].video);
		player.loadVideoById({ videoId: matches[selectedMatch].video, startSeconds: 3 });
		$("#no-match-selected")?.removeClass('display-inline').addClass('display-none');
		$("#video-container")?.removeClass('display-none').addClass('display-inline');
		if (muted) player.mute();
		else player.unMute();
		//player.cueVideoById({videoId:matches[match+1].video, startSeconds:3});
		// $('<iframe width="100%" height="100%" title="YouTube video player" frameborder="0" allow=accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>')
		// 	.attr('src', `https://www.youtube.com/embed/${matches[match].video}?mute=1&enablejsapi=1&autoplay=1&start=3&rel=0&controls=0`)
		// 	.appendTo('#video-container');
		$('#App').addClass(`${matches[selectedMatch].alliance}-alliance`);
	}, [selectedMatch, matches]);

	// Blur input boxes on team/event selections
	useEffect(() => {
		$('input').trigger('blur');
	}, [selectedEvent, selectedTeam]);

	useEffect(() => {
		if (paused) player?.pauseVideo();
		else player?.playVideo();
	}, [paused]);

	// Key press listener
	const handleKeyPress = (event) => {
		console.log(event);
		if (event.key === 'm') {
			const mute = !muted;
			if (player !== undefined && !mute) player?.unMute();
			else if (player !== undefined) player?.mute();
			setMuted(mute);
		}
		if (event.key === 'ArrowLeft') {
			if (player !== undefined) player.seekTo(player.getCurrentTime() - 5);
		}
		if (event.key === 'ArrowRight') {
			if (player !== undefined) player.seekTo(player.getCurrentTime() + 5);
		}
		if (event.key === ' ') {
			if (player !== undefined && player.getPlayerState() === 2) player.playVideo();
			else if (player !== undefined) player.pauseVideo();
		}
		if (event.key === '[') {
			if (selectedMatch > 0) setSelectedMatch(selectedMatch - 1);
		}
		else if (event.key === ']') {
			if (selectedMatch < matches.length - 1) setSelectedMatch(selectedMatch + 1);
		}
		// console.log('Set to match ', selectedMatch);
	};

	useEffect(() => {
		document.addEventListener('keydown', handleKeyPress);
		return () => {
			document.removeEventListener('keydown', handleKeyPress);
		};
	});

	return (
		<div id="App">
			<Grid centered padded verticalAlign='middle'>
				<Grid.Row id='selectors' verticalAlign="middle" centered>
					<Grid.Column width={2}>
						<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', paddingLeft: '20px'}}>
							<div class='icon-container'>
								<Icon name='question' onClick={() => setShowHelp(true)} size='big' />
							</div>
							<div class='icon-container'>
								<Icon name={muted? 'volume off' : 'volume up'} onClick={() => handleKeyPress({key: 'm'})} size='big' />
							</div>
						</div>
					</Grid.Column>
					<Grid.Column width={9}>
						<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
							<Dropdown id='dropDownYear' placeholder='Year' search selection options={yearDropdownOptions} defaultValue={selectedYear} onChange={(event, data) => setSelectedYear(data.value)} selectOnBlur={false} />
							<Dropdown id='dropDownEvent' placeholder='Event' value={selectedEvent} search selection options={eventDropdownOptions} disabled={!selectedYear || loading} loading={loading} onChange={(event, data) => setSelectedEvent(data.value)} selectOnBlur={false} />
							<Dropdown id='dropDownTeam' placeholder='Team' value={selectedTeam} search selection options={teamDropdownOptions} disabled={!selectedYear || loading} loading={loading} onChange={(event, data) => setSelectedTeam(data.value)} selectOnBlur={false} />
							<div class='icon-container'>
								<Icon name='close' onClick={clearSelection} size='big' />
							</div>
						</div>
					</Grid.Column>
					<Grid.Column width={2} centered>
						<div id='match-title'>{matchTitle}</div>
					</Grid.Column>
					<Grid.Column width={3}>
						<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'right', paddingRight: '20px'}}>
							<div class='icon-container'>
								<Icon name='step backward' onClick={() => setSelectedMatch(selectedMatch - 1)} size='big' className={selectedMatch <= 0 ? 'button-disabled' : ''} />
							</div>
							<div class='icon-container'>
								<Icon name='fast backward' onClick={() => player?.seekTo(player?.getCurrentTime() - 5)} size='big' />
							</div>
							<div class='icon-container'>
								<Icon name={paused? 'play' : 'pause'} onClick={() => setPaused(!paused)} size='big' />
							</div>
							<div class='icon-container'>
								<Icon name='fast forward' onClick={() => player?.seekTo(player?.getCurrentTime() + 5)} size='big' />
							</div>
							<div class='icon-container'>
								<Icon name='step forward' onClick={() => setSelectedMatch(selectedMatch + 1)} size='big' className={selectedMatch >= matches.length - 1 ? 'button-disabled' : ''} />
							</div>
						</div>
					</Grid.Column>
				</Grid.Row>
			</Grid>
			<div id='no-match-selected' className='display-inline'>
				{loading? 
					<h1>Loading...</h1>
				:(selectedTeam === null && selectedEvent === null)?
					<h1>Select a team or event to get started.</h1>
				: selectedTeam === null?
					<h1>Select a team.</h1>
				: selectedEvent === null?
					<h1>Select an event.</h1>
				: ''}
			</div>
			<div id='video-container' className='display-none' />
			<Modal
				onClose={() => setShowHelp(false)}
				onOpen={() => setShowHelp(true)}
				open={showHelp}
			>
				<Segment inverted padded='very'>
					<Header as={'h1'} style={{fontSize: 50}}>Controls</Header>
					<br />
					<div style={{fontSize: 30, marginBottom: '40px'}}>
						<span className='keybind'><kbd>[</kbd></span>Previous match
					</div>
					<div style={{fontSize: 30, marginBottom: '40px'}}>
						<span className='keybind'><kbd>]</kbd></span>Next match
					</div>
					<div style={{fontSize: 30, marginBottom: '40px'}}>
						<span className='keybind'><kbd>←</kbd></span>Rewind 5 seconds
					</div>
					<div style={{fontSize: 30, marginBottom: '40px'}}>
						<span className='keybind'><kbd>→</kbd></span>Fast forward 5 seconds
					</div>
					<div style={{fontSize: 30, marginBottom: '40px'}}>
						<span className='keybind'><kbd>m</kbd></span>Mute / unmute
					</div>
					<div style={{fontSize: 30, marginBottom: '40px'}}>
						<span className='keybind'><kbd>space</kbd></span>Pause / play
					</div>
					<div style={{fontSize: 30, color: '#fff200'}}>
						Important: if you click on the video, you must click back off 
						for the controls to work (e.g. somewhere in the red/blue area)
					</div>
				</Segment>
			</Modal>
		</div>
	);
}

export default App;